// This flag is tab-local. Never persist an organization choice in localStorage.
export const ORGANIZATION_ACCESS_KEY = 'inteloptics_organization_access';
export const isClientView = typeof window !== 'undefined' &&
    (window.location.pathname === '/client-access' || sessionStorage.getItem(ORGANIZATION_ACCESS_KEY) === 'client');
export const isOrganizationAccess = typeof window !== 'undefined' &&
    (isClientView || window.location.pathname === '/admin-access' || sessionStorage.getItem(ORGANIZATION_ACCESS_KEY) === 'active');
export const fullWorkspaceAccess = isOrganizationAccess && !isClientView;

// Workspace drafts belong to this tab and must disappear at logout.
export const clientWorkspaceStorage = () => sessionStorage;
